// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem, Label, Input, Col,
  Row, 
  Table,FormGroup} from "reactstrap";

import TableWithSortPagtn from "../../common/TableWithSortPagtn";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import ReactModal from 'react-modal';
import api from "../../../apis/api";
import Calendar from "react-calendar";
import { red } from "@material-ui/core/colors";
import "../../../style/processleave.css";
import { set } from "react-ga";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import Notifications from "../../../components/common/Notifications";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ProcessLeaves = React.memo(
  ({
    leaverequestDetails,
    myleavedetailedlist,
    myappliedleavelist,
    handlerecholidayCalendarArray,
    handleleavestatus,
    empTask,
    handleSelectedTask,
    handleDelTask,
    dateArray,
    handlecancelprocess,
    reloaddata
  }) => {
    const [thead] = useState([
      "Name",
      "Type",
      "Applied",
      "DateFrom",
      "DateTo",
      "Days",
      "Status",
      "Action",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [leavelist,setleavelist]=useState([]);
    const [isOpen, setIsOpen] = useState(false);
   
    // const [dateArray,setDateArray]=useState([]);
    const [comment,setcomment]=useState("");
    const [calenderDate] = useState(new Date());
    const [action ,setaction] =useState("");
    const [approve,setapprove] =useState(false);
    const [reject,setreject] = useState(false);
      const [error, setError] = useState(null);
      const [loaded, setLoaded] = useState(false);
         
        const DarkBackground = styled.div`
        display: none; /* Hidden by default */
          position: fixed; /* Stay in place */
          z-index: 999; /* Sit on top */
          left: 0;
          top: 0;
          width: 100%; /* Full width */
          height: 100%; /* Full height */
          overflow: auto; /* Enable scroll if needed */
          background-color: rgb(0, 0, 0); /* Fallback color */
          background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
        ${(props) =>
          props.disappear &&
          css`
            display: block; /* show */
          `}
        `;
    // const [comment,setcomment] =useState("")
    const buttonStyles = {
      position: "absolute",
      top: "10px",
      right: "10px"
    };
    let holidaylist=[];
    handlerecholidayCalendarArray.map(function (hol){
    holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
  });

  let leavestatuslist=[];
  handleleavestatus.map(function (hol){
    leavestatuslist.push({value :hol.leaveStatusId,label :hol.status});
});
    useEffect(() => {
      setleavelist(empTask);

    },[empTask])
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

  //  const handledelAppliedleave =React.useCallback((leave) =>{
  //   delAppliedLeaves(leave);
  //  },[delAppliedLeaves])

  const handleSaveForm =React.useCallback((leaverequestId) =>{
    setLoaded(true);
    if(action !="")
    {
      const fetchApi = async () => {
        let arr=[];
     
       const res= await api
        .dbCalendarYear()
        .ApproveLeaveRequest(parseInt(leaverequestId),parseInt(action),comment);
        setError({ ...error, message: "Leave Approved Successfully..", status: 200 });
      }
      const fetchApirej = async () => {
        let arr=[];
     
       const res= await api
        .dbCalendarYear()
        .RejectLeaveRequest(parseInt(leaverequestId),parseInt(action),comment);
        setError({ ...error, message: "Leave Rejected Successfully..", status: 200 });
      }
      if(approve==true)
      {
        fetchApi();
      }
      else
      {
        fetchApirej();
      }
      setTimeout(() => { 
        setLoaded(false);
     reloaddata();
        // window.location.reload();

    }, 4000);
    }
    
  else
  {
    alert("Please select Approve/Reject action");
  }
     },[approve,reject])

const handlesetaction =React.useCallback((val,id) =>{

if(id===1)
{
setapprove(true);
setreject(false);
setaction(val);
}
else
{
setaction(val);
setapprove(false);
setreject(true);
}
},[setapprove,setreject,setaction]);

const handleCloseForm =React.useCallback(() =>{
  handlecancelprocess();
})
    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);
  
  //   const getDates = (myappliedleavelist) => {
  //     const dates = [];
  //     myappliedleavelist.forEach(element => {
  //       if (element.fromDate && element.toDate) {
  //         const start = new Date(element.fromDate);
  //         const end = new Date(element.toDate);
  //         const days = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          
  //         for (let i = 0; i <= days; i++) {
  //             const currentDate = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
  //             dates.push(moment(currentDate).format("DD-MM-YYYY"));
  //         }
        
  //     }
  //     });
  //     setDateArray(dates);
  // };
    
    return (
      <div className="divstyle">
      <Fragment>

          

        
        <Row>
      <Col>
        <h3>Leave Request Details</h3>
      </Col>
      <Col>
        
     
        </Col>
      </Row>

          <Row>
            <Col>
            <Label>Name : </Label>
            <Label>{leaverequestDetails.length>0? leaverequestDetails[0].employeeName : null}</Label>
            </Col>
            <Col>
            <Label>Department : </Label>
            <Label>{leaverequestDetails.length>0? leaverequestDetails[0].departmentName :null}</Label>
            </Col>
            <Col>
            <Label>Designation : </Label>
            <Label>{leaverequestDetails.length>0?leaverequestDetails[0].designationName : null}</Label>
            </Col>
          </Row>
          {/* <Row>
            <Col md={12}>
            {myleavedetailedlist.length >0 ? (<Table>
            <tr>
                    <th>Type</th>
                    <th>Leaves Per Year</th>
                    <th>Balance Leave</th>
                </tr>
                {myleavedetailedlist.map((val, key) => {
                    return (
                        <tr key={key}>
                            <td>{val.type}</td>
                            <td>{val.noOfLeavesPerYear}</td>
                            <td>{val.leaveBalance}</td>
                        </tr>
                    )
                })}
            </Table>) :null}  
            </Col>
          
          </Row> */}
          <br/>
          <Row>
            <Col md={12}>
            {myappliedleavelist.length >0 ? (<Table>
            <tr>
              <th>Applied</th>
                    <th>Date From</th>
                    <th>Date To</th>
                    <th>Type</th>
                    <th>Reason</th>
                    <th>Day(s)</th>
                    <th>Leave(s) Taken</th>
                </tr>
                {myappliedleavelist.map((val, key) => {
                    return (
                        <tr key={key}>
                            <td>{moment(val.createdDate).format("DD-MM-YYYY")}</td>
                            <td>{moment(val.fromDate).format("DD-MM-YYYY")}</td>
                            <td>{moment(val.toDate).format("DD-MM-YYYY")}</td>
                            <td>{val.type}</td>
                            <td>{val.reason}</td>
                            <td>{val.noOfDays}</td>
                            <td>{val.noOfDays}</td>
                        </tr>
                    )
                })}
            </Table>) :null}  
            </Col>
          
          </Row>
          <br/>
          <Row>
            <Col md={6}>
            <Table>
              <tr>
                <th>Work Hand Over To</th>
                <th>Contact Details</th>
              </tr>
              <tr>
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].workHandOverTo : null}</td>
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].contactDetails : null}</td>
              </tr>
            </Table>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col md={6}>
              <Table>
            <tr>
                <th>Approver</th>
                <th>Status</th>
              </tr>
              <tr>
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].approver : null}</td>
                <td>{leaverequestDetails.length>0? leaverequestDetails[0].leaveStatus : null}</td>
              </tr>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
            <Label>Comment</Label>
            <Input
              type="text"
              value={comment}
              onChange={(e) => setcomment(e.target.value)}
            />
            </Col>
            <Col md={2}>
              {/* <Label>Action</Label> */}
              {/* {leavestatuslist.map((el) => {
         <Label>
                  Test
                   </Label>
                }
              )} */}
  {leavestatuslist.map((list, index) => (
        list.label !== "Pending" && list.label == "Approved" ? (
           <div key={index}> 
            <input
              type="radio"
              name="leave-status"
              value="Approved"
              checked={action === list.value}
              onChange={() => handlesetaction(list.value, 1)}
            />
            <label>Approved</label> </div>) : list.label !== "Pending" && list.label == "Rejected" ? (

<div key={index}> <input
              type="radio"
              name="leave-status"
              value="Rejected"
              checked={action === list.value}
              onChange={() => handlesetaction(list.value, 2)}
            />
            <label>Rejected</label></div> ) : (null)
           
        )
      )} 
       
              {/* <Input
            type="select"
            
            value={action}
            onChange={(e) => setaction(e.target.value)}
          >
            <option value={""}>Select Action</option>
            {leavestatuslist.map((el) => (
              <option key={el.value} value={el.value}>
                {el.label}
              </option>
            ))}
          </Input> */}
            </Col>
            <Col md={4} className=" newstyle">
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Label style={{ marginBottom: 0 }}>Holiday</Label>
                            <Button className="btn btn-secondary" style={{ background: "red", border: "none", width: "20px", height: "20px", padding: 0 }} />
                          </div>
                        
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Label style={{ marginBottom: 0 }}>Leave(s)Applied</Label>
                            <Button className="btn btn-secondary" style={{ background: "green", border: "none", width: "20px", height: "20px", padding: 0 }} />
                          </div>
                        </div>
            <Calendar
              // onChange={(date) => props.handleOnchangeDate(date)}
              
              value={calenderDate}
              tileClassName={({ date, view }) => {
                if(holidaylist.find(x=>x===moment(date).format("DD-MM-YYYY"))){
                 return  'highlight'
                }
                else if(dateArray.find(x=>x===moment(date).format("DD-MM-YYYY"))){
                  return  'leavehighlight'
                 }
              }}
          
              disabledKeyboardNavigation
            />
            </Col>
          </Row>
          <br/>
          <br/>
          <Row className="detailslist">
            <Col md={3}></Col>
            <Col md={3}><Button
             color=""
             className="btn-admin-settings"
               onClick={() => handleSaveForm(leaverequestDetails[0].leaveRequestId)}
            >
              Save
            </Button> &nbsp; <Button color="" className="btn-cancel"  onClick={() => handleCloseForm()}>
              Cancel
            </Button></Col>
            <Col md={3} >
           
            </Col>
            <Col md={3}></Col>
          </Row>
          <Notifications notifications={error}></Notifications>
          <DarkBackground disappear={loaded}>
              <LoadingOverlay
                    active={true}
                    spinner={true}
                    text="Loading your content..."
                  >
                  </LoadingOverlay>
              </DarkBackground>
          </Fragment>
      </div>
    );
  }
);

export default ProcessLeaves;
